import React from 'react'
import SectionTitle from '../SectionTitle'
import sImg1 from '../../images/event/1.jpg'
import sImg2 from '../../images/event/2.png'
import sImg3 from '../../images/event/3.png'


import LocationMap from './Modal'
import LocationMap2 from './Modal2'


const EventSection = (props) => {
    return (
        <section className="wpo-event-section section-padding" id="event">
            <div className="container">
                <SectionTitle subTitle={'El Evento'} MainTitle={'Cuándo y Dónde'} />
                <div className="wpo-event-wrap">
                    <div className="row align-items-stretch">
                        <div className="col-lg-4 col-md-12">
                            <div className="wpo-event-item h-100">
                                <div className="wpo-event-text">
                                    <div className="title">
                                        <h2>Traslado en trajinera</h2>
                                    </div>
                                    <div className="wpo-event-img">
                                        <div className="wpo-event-img-inner">
                                            <img src={sImg3} alt="Hacienda Zacapa" />
                                        </div>
                                    </div>
                                    <ul>
                                        <li>16:00</li>
                                        <li>Estacionamiento Zacapa</li>
                                        <li><LocationMap2 /></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="wpo-event-item h-100">
                                <div className="wpo-event-text">
                                    <div className="title">
                                        <h2>Recepción</h2>
                                    </div>
                                    <div className="wpo-event-img">
                                        <div className="wpo-event-img-inner">
                                            <img src={sImg1} alt="Hacienda Zacapa" />
                                        </div>
                                    </div>
                                    <ul>
                                        <li>17:00</li>
                                        <li>Hacienda Zacapa <a href="https://instagram.com/haciendazacapa" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                                        <li> Xochimilco, CDMX</li>
                                        <li><LocationMap /></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="wpo-event-item h-100">
                                <div className="wpo-event-text">
                                    <div className="title">
                                        <h2>Código de vestimenta</h2>
                                    </div>
                                    <div className="wpo-event-img">
                                        <div className="wpo-event-img-inner">
                                            <img src={sImg2} alt="Hacienda Zacapa" />
                                        </div>
                                    </div>
                                    <ul>
                                        <li>Formal (cómodo)</li>
                                        <li>
                                            Nos reservamos el color blanco, sage y verde botella
                                            <div className="color-circle-container">
                                                <div className="color-circle" style={{
                                                    display: 'inline-block',
                                                    width: '50px',
                                                    height: '50px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#ffffff',
                                                    marginLeft: '20px',
                                                    marginTop: '10px',
                                                    marginBottom: '10px',
                                                    border: '10px solid #F1F3EE',
                                                    boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                                                    padding: '0'
                                                }}></div>
                                                <div className="color-circle" style={{
                                                    display: 'inline-block',
                                                    width: '50px',
                                                    height: '50px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#bdd1b6',
                                                    marginLeft: '20px',
                                                    marginTop: '10px',
                                                    marginBottom: '10px',
                                                    border: '10px solid #F1F3EE',
                                                    boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                                                    padding: '0'
                                                }}></div>
                                                <div className="color-circle" style={{
                                                    display: 'inline-block',
                                                    width: '50px',
                                                    height: '50px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#00543e',
                                                    marginLeft: '20px',
                                                    marginTop: '10px',
                                                    marginBottom: '10px',
                                                    border: '10px solid #F1F3EE',
                                                    boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                                                    padding: '0'
                                                }}></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventSection;